import React  from "react";
import rawHtml  from 'html-react-parser';
import { TaskRewardStatusType } from "~/services/tasks";
import CheckMark from "../CheckMark";
import TaskImg from "~/assets/images/task/task.png"

const ClaimedTaskCard = ({item, setSelectedTask, setOverlayOpen})=> {

  const pendingTask = item.status === TaskRewardStatusType.PENDING;

  return (
    <div key={item.id} onClick={()=>{ setSelectedTask(item); setOverlayOpen(true); }} style={{opacity: pendingTask? 0.8 : 1}} className="item">
      <CheckMark task={item} />
      <div className="short-description">
        <h5> {item.title} </h5>
         { pendingTask ? <p>Your submit for this task is being processed!</p> : rawHtml(item.shortDescription || '') }
         <p> <small>Points: { item.status === TaskRewardStatusType.REJECTED ? 0 : item.points } </small> </p>
      </div>
      <img src={item.icon || TaskImg} className="b-r-10 " style={{ width: 50}} />
    </div>
  );
};

export default ClaimedTaskCard;
